import React from "react";
import { Navbar,  Container,  Image } from "react-bootstrap";


import { useScreenSize } from "provider/ScreenSizeProvider";


const HeaderPayment = () => {
 const { isMobileView } = useScreenSize();
  return (
    <>
      <header className="header_wrapper">
        <Navbar expand="lg">
          <Container fluid>
              <Image
                src={"/img/WLogoLightgreen.svg"}
                alt="logo"
                width="40px"
                className="logo pt-1"
              />
            {!isMobileView && (
              <div className="d-flex align-items-center d-lg-block d-none">
                <Navbar.Toggle aria-controls="offcanvasNavbar" />
              
              </div>
            )}
          </Container>
        </Navbar>
      </header>
      {isMobileView && (
        <div className="Mobile_navbar">
          <div className="container-fluid">
            <div className="d-flex justify-content-between">
             
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderPayment;
